module.exports = __webpack_public_path__ + "img/man.c03129c7.jpg";